import { render, staticRenderFns } from "./PointVoucher.vue?vue&type=template&id=b44dcf82&scoped=true&"
import script from "./PointVoucher.vue?vue&type=script&lang=js&"
export * from "./PointVoucher.vue?vue&type=script&lang=js&"
import style0 from "./PointVoucher.vue?vue&type=style&index=0&id=b44dcf82&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b44dcf82",
  null
  
)

export default component.exports